import { initGraphQLTada } from 'gql.tada'
import type { introspection } from '@/types/graphql-env'

export const graphql = initGraphQLTada<{
    introspection: introspection
    scalars: {
        MRN: string
    }
}>()
